export default __webpack_public_path__ + "infoSecondPart.8336ed4.png";